<template>
  <div class="tuolele-main-box sort-management-detail">
    <div class="tuolele-main-search tuolele-main-search-item">
      <el-form ref="search" :inline="true" :model="createHomeWorkListQuery" class="fn-clear" :rules="rules">
        <el-form-item label="" class="fn-left">
          <el-button type="default" @click="back()">返回</el-button>
        </el-form-item>
        <el-form-item label="起始时间" class="fn-left" prop="all_time">
          <el-date-picker
            v-model=" createHomeWorkListQuery.all_time"
            type="daterange"
            range-separator="至"
            :picker-options="pickerDisabled"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="calendarChange"
          />
        </el-form-item>
        <el-form-item label="年级" class="fn-left" prop="grade_id">
          <Select key="10" style="width: 130px;" :selected.sync="createHomeWorkListQuery.grade_id" :data="gradeLists" clearable placeholder="请选择年级" />
        </el-form-item>
        <el-form-item label="科目" class="fn-left" prop="subject_id">
          <Select key="11" style="width: 130px;" :selected.sync="createHomeWorkListQuery.subject_id" :data="subjectLists" clearable placeholder="请选择科目" />
        </el-form-item>
        <el-form-item label="错误次数" class="fn-left" prop="subject_id">
          <el-input-number v-model="createHomeWorkListQuery.error_num" :min="1" :max="100" label="错误次数(>=)" />
        </el-form-item>
        <el-form-item label="" class="fn-left">
          <el-button type="primary" @click="searchQuestion()">查询</el-button>
        </el-form-item>
        
        <el-form-item label="" class="fn-right">
          <el-button type="success" @click="createQuestionPDF()" >生成练习</el-button>
        </el-form-item>
      </el-form>
      <div style="color:#F56C6C">
        操作说明：
        <p>1、选择日期、科目、年级后点击查询</p>
        <p>2、选取要生成的题目</p>
        <p>3、点击右上角“生成练习”按钮</p>
        <p>4、生成后等待20秒左右可在练习列表页下载（需手动刷新）</p>
      </div>

    </div>
    <div class="table">
      <el-table
        ref="dataTable"
        :data="tableData"
        border
        stripe
        @selection-change="handleSelectChange"
      >
        <el-table-column type="selection" width="100px" />
        <el-table-column label="题目内容">
          <template slot-scope="scope">
            <div v-html="scope.row.html" />
          </template>
        </el-table-column>

        <el-table-column prop="q_type_name" label="题目类型" />

      </el-table>
    </div>

  </div>
</template>

<script>

import Select from '@/components/Select'
import { validateRequire } from '@/utils/validate'
var moment = require('moment')

const createHomeWorkListQueryDefault = {
  begin_time: '',
  all_time: [],
  end_time: '',
  grade_id: '',
  subject_id: '',
  error_num: ''
}

const createHomeWorkDefaultPostForm = {
  q_id: [],
  begin_time: '',
  end_time: '',
  grade_id: '',
  subject_id: '',
  error_num: ''
}

export default {
  name: 'CreateHomeWorkLists',
  components: { Select },
  data() {
    return {
      tableData: [],
      choiceDate: '',
      maxTime: null,
      minTime: null,
      workLists: [],
      createHomeWorkListQuery: Object.assign({}, createHomeWorkListQueryDefault),
      createHomeworkPostForm: Object.assign({}, createHomeWorkDefaultPostForm),
      gradeLists: [],
      subjectLists: [],
      multipleSelection: [],
      pickerDisabled: {
        onPick: (time) => {
          if (!time.maxDate) {
            const timeRange = 6 * 24 * 3600 * 1000
            this.minTime = time.minDate.getTime() - timeRange
            this.maxTime = time.minDate.getTime() + timeRange
          } else {
            this.minTime = null
            this.maxTime = null
          }
          // this.choiceDate = miniDate.getTime()
          // if (maxDate) this.choiceDate = ''
        },
        disabledDate: (time) => {
          if (this.maxTime && this.minTime) {
            return time.getTime() < this.minTime || time.getTime() > this.maxTime
          }
        }
      },
      rules: {
        all_time: [{ validator: validateRequire, trigger: 'manual', message: '起止时间' }],
        subject_id: [{ validator: validateRequire, trigger: 'manual', message: '科目' }],
        grade_id: [{ validator: validateRequire, trigger: 'manual', message: '年级' }]
      }
    }
  },
  mounted() {
    this.getBaisicData()
  },
  methods: {
    calendarChange(obj) {
      const minDate = obj[0]
      const maxDate = obj[1]
      this.choiceDate = minDate.getTime()
      if (maxDate) this.choiceDate = null
    },
    getBaisicData() {
      this.$http.getTeacherExercisesList().then(res => {
        this.gradeLists = []
        this.subjectLists = []
        Object.keys(res.data.grade).forEach((key) => { this.gradeLists.push({ id: key, name: res.data.grade[key] }) })
        Object.keys(res.data.subject).forEach((key) => { this.subjectLists.push({ id: key, name: res.data.subject[key] }) })
      })
    },
    searchQuestion: function() {
      this.$refs.search.validate(valid => {
        if (valid) {
          this.createHomeWorkListQuery.begin_time = moment(this.createHomeWorkListQuery.all_time[0]).format('YYYY-MM-DD')
          this.createHomeWorkListQuery.end_time = moment(this.createHomeWorkListQuery.all_time[1]).format('YYYY-MM-DD')
          this.$http.searchQuestionList(this.createHomeWorkListQuery).then(res => {
            this.tableData = res.data
            this.createHomeworkPostForm.begin_time = this.createHomeWorkListQuery.begin_time
            this.createHomeworkPostForm.end_time = this.createHomeWorkListQuery.end_time
            this.createHomeworkPostForm.grade_id = this.createHomeWorkListQuery.grade_id
            this.createHomeworkPostForm.subject_id = this.createHomeWorkListQuery.subject_id
            this.createHomeworkPostForm.error_num = this.createHomeWorkListQuery.error_num
            this.$nextTick(() => {
              this.$refs.dataTable.toggleAllSelection()
            })
          })
        }
      })
    },
    handleSelectChange(val) {
      console.log(val)
      this.createHomeworkPostForm.q_id = val.map((item) => item.q_id).join(',')
    },
    createQuestionPDF() {
      console.log(this.createHomeworkPostForm)
      if (this.createHomeworkPostForm.q_id.length == 0) {
        this.$message.error('请选择题目')
        return
      }
      this.$http.setQuestionExercises(this.createHomeworkPostForm).then(res => {
        this.$router.go(-1)
      })
    }, 
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss">
.sort-management-detail {
  .tuolele-main-search {
    padding-bottom: 20px;
  }
  .add-content-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    .add-content-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #333;
      opacity: 0.7;
    }
  }
  .add-content {
    width: 620px;
    background-color: #ffffff;
    box-shadow: 0px 6px 20px 0px rgba(148, 148, 148, 0.5);
    border-radius: 10px;
    .add-header {
      width: 100%;
      padding: 25px 30px;
      border-bottom: 1px solid #f5f5f5;
      .title {
        font-size: 22px;
        font-weight: normal;
        font-stretch: normal;
        color: #4c84ff;
      }
      .close {
        cursor: pointer;
        img {
          width: 18px;
          height: 18px;
        }
      }
    }
    .el-table tr th {
      background: #fff;
      color: #333;
    }
    .el-table td,
    .el-table th {
      border: 1px solid #ebebeb !important;
    }
  }
  .input1 {
    width: 211px;
    margin-right: 10px;
  }
  .add-content-main {
    display: flex;
    flex-direction: column;
    padding: 30px;
  }
  .add-content-table {
    margin: 20px auto;
  }
  .confirm-btn {
    margin: 50px 0 30px;
    .title {
      color: $color_black;
      margin-bottom: 10px;
      span {
        color: $color_blue;
      }
    }
  }
}
</style>
